// @flow
import * as React from 'react';
import Head from 'next/head';

import { OFFER_SEO } from 'Client/cms/toolkit/constants';
import { offerSEOResolver } from './offerSeo.resolver';

type Props = {|
  title: string,
  meta: $ReadOnlyArray<{ name: string, content: string }>,
|};

const SeoComponent = ({ title, meta }: Props) => (
  <Head>
    <title key="title">{title}</title>
    {meta.map(({ name, content }) => (
      <meta key={name} content={content} name={name} />
    ))}
  </Head>
);

export const offerSEODescriptor = {
  name: OFFER_SEO,
  component: SeoComponent,
  props: offerSEOResolver.props,
  resolve: offerSEOResolver.resolve,
};
